/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListProjectsVideoEditorProjectsQueryResponse, ListProjectsVideoEditorProjectsQueryParams } from "../models/ListProjectsVideoEditorProjects";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listProjectsVideoEditorProjects } from "../axios/listProjectsVideoEditorProjects";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listProjectsVideoEditorProjectsQueryKey = (params: ListProjectsVideoEditorProjectsQueryParams) => ["web-app-bff-api", { url: '/video-editor/projects' }, ...(params ? [params] : [])] as const

export type ListProjectsVideoEditorProjectsQueryKey = ReturnType<typeof listProjectsVideoEditorProjectsQueryKey>

export function listProjectsVideoEditorProjectsQueryOptions(params: ListProjectsVideoEditorProjectsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listProjectsVideoEditorProjectsQueryKey(params)
        return queryOptions<ListProjectsVideoEditorProjectsQueryResponse, ResponseErrorConfig<Error>, ListProjectsVideoEditorProjectsQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return listProjectsVideoEditorProjects(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List projects for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /video-editor/projects}
 */
export function useListProjectsVideoEditorProjects<TData = ListProjectsVideoEditorProjectsQueryResponse, TQueryData = ListProjectsVideoEditorProjectsQueryResponse, TQueryKey extends QueryKey = ListProjectsVideoEditorProjectsQueryKey>(params: ListProjectsVideoEditorProjectsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListProjectsVideoEditorProjectsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? listProjectsVideoEditorProjectsQueryKey(params)
         

         const query = useQuery({
          ...listProjectsVideoEditorProjectsQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}